import { getGatewayApiUrl } from "./backendUrl";
import { FrontendApiError, normalizeApiError } from "./problem";

const CSRF_COOKIE = "XSRF-TOKEN";
const CSRF_HEADER = "X-XSRF-TOKEN";

let bootstrapPromise: Promise<string> | null = null;

export function readCsrfToken(cookie = document.cookie): string | null {
  const token = cookie
    .split(";")
    .map((part) => part.trim())
    .find((part) => part.startsWith(`${CSRF_COOKIE}=`))
    ?.slice(CSRF_COOKIE.length + 1);

  return token ? decodeURIComponent(token) : null;
}

export function bootstrapCsrf(): Promise<string> {
  const existing = readCsrfToken();
  if (existing) return Promise.resolve(existing);

  bootstrapPromise ??= fetch(getGatewayApiUrl("/csrf"), { credentials: "include" })
    .then(async (response) => {
      if (!response.ok) throw await normalizeApiError(response);
      const token = readCsrfToken();
      if (!token) {
        throw new FrontendApiError(
          "CSRF bootstrap failed",
          503,
          "CSRF_BOOTSTRAP_FAILED",
          true,
          response.headers.get("x-correlation-id") ?? ""
        );
      }
      return token;
    })
    .finally(() => {
      bootstrapPromise = null;
    });

  return bootstrapPromise;
}

export async function csrfHeaders(): Promise<Record<string, string>> {
  return { [CSRF_HEADER]: await bootstrapCsrf() };
}

export function resetCsrfForTests(): void {
  bootstrapPromise = null;
}
